import { render, staticRenderFns } from "./MainContentExtra.vue?vue&type=template&id=4612a792&scoped=true"
import script from "./MainContentExtra.vue?vue&type=script&lang=js"
export * from "./MainContentExtra.vue?vue&type=script&lang=js"
import style0 from "./MainContentExtra.vue?vue&type=style&index=0&id=4612a792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612a792",
  null
  
)

export default component.exports